$(() => {
  $('.bxslider').bxSlider({
    auto: 'true',
    pause: 6000,
    speed: 1000,
    prevText: '<i class="fa fa-angle-left"></i>',
    nextText: '<i class="fa fa-angle-right"></i>',
    onSlideAfter: function (currentSlideNumber, totalSlideQty, currentSlideHtmlObject) {
      $('.active-slide').removeClass('active-slide');
      $('.bxslider>li').eq(currentSlideHtmlObject + 1).addClass('active-slide')
    },
    onSliderLoad: function () {
      $('.bxslider>li').eq(1).addClass('active-slide')
    },
  });
});